(ns cljsjs.react
  (:require ["react" :as react]))

(js/goog.exportSymbol "React" react)